
(function () {

    'use strict';
    angular.module('app')
        .directive('repeatPassword',
            function () {
                return {
                    require: 'ngModel',
                    link: function (scope, elem, attrs, ctrl) {
                        var otherInput = elem.inheritedData('$formController')[attrs.repeatPassword];

                        ctrl.$parsers.push(function (value) {
                            if (value === otherInput.$viewValue) {
                                ctrl.$setValidity('repeat', true);
                                return value;
                            }
                            ctrl.$setValidity('repeat', false);
                        });

                        otherInput.$parsers.push(function (value) {
                            ctrl.$setValidity('repeat', value === ctrl.$viewValue);
                            return value;
                        });
                    }
                };
            });

})();

(function() {

    'use strict';
    angular.module('app')
        .directive('ngPasswordStrengthIndicator',
            function() {
                return {
                    restrict: 'A',
                    templateUrl: 'assets/templates/password_strength_indicator.html',
                    scope: {
                        ngModel: '=',
                        rulesPassed: '='
                    },
                    link: function(scope, element, attrs, ctrl) {
                        scope.passwordInput = element.inheritedData('$formController')[attrs.ngPasswordInput];

                        function rule(description, validator) {
                            this.description = description;
                            this.className = function() {
                                return this.valid() ? 'fa fa-check-circle' : 'fa fa-exclamation-circle';
                            };
                            this.valid = validator;
                        }

                        scope.rulesPassed = function() {
                            var passed = 0;

                            angular.forEach(scope.rules,
                                function(rule) {
                                   if (rule.valid()) {
                                       passed++;
                                   }
                                });

                            return passed;
                        };

                        scope.rules = [
                            new rule('Contains a digit',
                                function() {
                                    return scope.passwordInput.$viewValue == undefined
                                        ? false
                                        : scope.passwordInput.$viewValue.match(/[0-9]/);
                                }),
                            new rule('Contains an upper case character',
                                function() {
                                    return scope.passwordInput.$viewValue == undefined
                                        ? false
                                        : scope.passwordInput.$viewValue.match(/[A-Z]/);
                                }),
                            new rule('Contains a lower case character',
                                function() {
                                    return scope.passwordInput.$viewValue == undefined
                                        ? false
                                        : scope.passwordInput.$viewValue.match(/[a-z]/);
                                }),
                            new rule('Contains a symbol',
                                function() {
                                    return scope.passwordInput.$viewValue == undefined
                                        ? false
                                        : scope.passwordInput.$viewValue
                                        .match(/[-!#$%^&*()_+|~=`{}\[\]:";'<>?,.\/\\@¬€¦£]/);
                                }),
                            new rule('12 or more characters',
                                function () {
                                    return scope.passwordInput.$viewValue == undefined
                                        ? false
                                        : scope.passwordInput.$viewValue.length > 11;
                                })
                        ];

                      

                    }
                };
            });
})();

(function() {

    'use strict';
    angular.module('app')
        .directive('rotateText',
        [
            '$interval', function($interval) {

                return function(scope, element, attrs) {


                    function updateDidYouKnow(i) {
                        var j = (i + 1) % scope.model.DidYouKnowMessages.length; //(i+1) to start at second word
                        //console.log(j);
                        element.html(scope.model.DidYouKnowMessages[j]);
                    }

                    element.html(scope.model.DidYouKnowMessages[0]); //displays "fun"
                    var stopWord = $interval(updateDidYouKnow, 10000); //start rotating 1 second after, changes every sec

                    // listen on DOM destroy (removal) event
                    // to prevent updating word after the DOM element was removed.
                    element.on('$destroy',
                        function() {
                            $interval.cancel(stopWord);
                        });
                }
            }
        ]);
})();

(function() {

    'use strict';
    angular.module('app')
        .directive('onlyDigits',
            function() {

                return {
                    restrict: 'A',
                    require: '?ngModel',
                    link: function(scope, element, attrs, ngModel) {
                        if (!ngModel) return;
                        ngModel.$parsers.unshift(function(inputValue) {
                            var digits = inputValue.split('')
                                .filter(function(s) { return (!isNaN(s) && s != ' '); })
                                .join('');
                            ngModel.$viewValue = digits;
                            ngModel.$render();
                            return digits;
                        });
                    }
                }
            });
})();


(function() {

    'use strict';
    angular.module('app')
        .directive('ipaddress',
            function() {
                return {
                    require: 'ngModel',
                    link: function(scope, elem, attrs, ctrl) {
                        ctrl.$validators.ipaddress = function(modelValue, viewValue) {
                            if (ctrl.$isEmpty(modelValue)) {
                                ctrl.$setValidity('ipaddress', true);
                                return true;
                            }
                            var matcher;
                            if ((matcher = viewValue
                                    .match(/^([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/)) !=
                                null) {
                                var i;
                                var previous = '255';
                                for (i = 1; i < 5; i++) {
                                    var octet = parseInt(matcher[i]);
                                    if (octet > 255) {
                                        ctrl.$setValidity('ipaddress', false);
                                        return false;
                                    }
                                }
                                ctrl.$setValidity('ipaddress', true);
                                return true;
                            } else {
                                ctrl.$setValidity('ipaddress', false);
                                return false;
                            }
                        }
                    }
                }
            });
})();

(function() {

    'use strict';
    angular.module('app')
        .directive('myEnter',
            function() {
                return function(scope, element, attrs) {
                    element.bind('keydown keypress',
                        function(event) {
                            if (event.which === 13) {
                                scope.$apply(function() {
                                    scope.$eval(attrs.myEnter);
                                });

                                event.preventDefault();
                            }
                        });
                };
            });
})();

(function () {

    'use strict';
    angular.module('app').directive('focusMe', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
        //scope: true,   // optionally create a child scope
        link: function (scope, element, attrs) {
            var model = $parse(attrs.focusMe);
            scope.$watch(model, function (value) {
                console.log('value=', value);
                if (value === true) {
                    $timeout(function () {
                        element[0].focus();
                    });
                }
            });
            // to address @blesh's comment, set attribute value to 'false'
            // on blur event:
            element.bind('blur', function () {
                console.log('blur');
                scope.$apply(model.assign(scope, false));
            });
        }
    };
    }]);
})();